<template>
  <div class="kft-article-quote" :class="getClassName">
    <div v-if="image" class="quote-image">
      <img :src="image" alt="" loading="lazy" />
    </div>
    <div class="quote-content-container">
      <div class="quote-content">
        <div v-if="title" class="title">{{ title }}</div>
        <div v-if="quoteString" class="text">
          {{ quoteString }}
        </div>
        <div v-if="quoteAuthorString" class="author">
          — {{ quoteAuthorString }}
        </div>
        <div class="w-full flex justify-center">
          <NuxtLink
            v-if="buttonLabel && buttonLink"
            class="mt-3"
            :to="buttonLink"
          >
            <Button class="font-normal">
              {{ buttonLabel }}
            </Button>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title?: string
    quoteString?: string
    quoteAuthorString?: string
    buttonLabel?: string
    buttonLink?: string
    image?: string
  }>(),
  {
    title: '',
    quoteString: '',
    quoteAuthorString: '',
    buttonLabel: '',
    buttonLink: '',
    image: '',
  }
)

const getClassName = computed((): string => {
  if (!props.image && !props.title && !props.buttonLabel) return 'quote'

  if (!props.image) return 'cta'

  return 'default'
})
</script>

<style lang="css" scoped>
@reference '~/assets/css/tailwind.css';
.kft-article-quote {
  @apply w-full bg-white p-5 rounded-xl border border-stone-200 flex flex-col md:flex-row gap-8 mb-8;

  &.cta {
    @apply md:max-w-[500px] md:mx-auto;
  }

  &.quote {
    .text,
    .author {
      @apply text-lg text-stone-900;
    }

    .author {
      @apply mt-1.5;
    }
  }
}

.quote-content-container {
  @apply flex items-center;
}

.quote-content {
  @apply flex flex-col;
}

.text,
.author {
  @apply text-base text-gray-900 text-center;
}

.title {
  @apply text-center mb-2.5 text-lg font-semibold text-stone-900;
}

.quote-image {
  @apply relative w-full md:w-[280px] md:min-w-[280px] md:max-w-[280px] min-h-[190px] overflow-hidden rounded-lg;

  img {
    @apply w-full h-full rounded-lg m-0 object-cover;
  }
}
</style>
